/**
 * Rocnovel 品牌 - Subscribe 页面配置
 */
import { commonTexts } from './common'
import type { SubscribePageConfig } from './types'
import { colors as brandColors } from '@/config/brands'

export const resources = {
  vipBg: '/images/rocnovel/vip_bg.webp',
  memberSubscribeBg: '/images/rocnovel/member_subscribe_bg.webp',
  vipIcon: '/images/rocnovel/vip_icon2.png',
  vipDiscountIcon: '/images/rocnovel/vip_discount.png',
  discountBg: '/images/rocnovel/discount.avif',
} as const

export const colors = {
  redGradient: 'linear-gradient(132deg, #F961BC 0%, #F74984 100%)',
  purpleTextGradient: 'linear-gradient(180deg, #BEA9FF 0%, #D3C5FB 70%, #F3EFFF 100%)',

  subscribeText1: brandColors!.primary,
  subscribeText2: brandColors!.text.primary,
  subscribeText3: brandColors!.text.secondary,
  subscribeText4: brandColors!.text.secondary,
} as const

export const subscribeConfig: SubscribePageConfig = {
  texts: commonTexts,
  resources,
  colors,
}
